import { combineReducers } from "redux";
import categories from "./categories";
import common from "./common";
import memos from "./memos";
import setting from "./setting";
import user from "./user";
import layout from "./layout";

export default combineReducers({
  categories,
  common,
  memos,
  setting,
  user,
  layout
});
